import { useConfigStore } from '@/stores';
import { useMemo } from 'react';

export const useFloorCategory = (selectedFloorName?: string, currentMapBuildingId?: string) => {
    const buildings = useConfigStore((state) => state?.config?.server?.store?.buildings);

    const currentBuilding = useMemo(() => {
        if (!Array.isArray(buildings) || !currentMapBuildingId) {
            return null;
        }
        return buildings.find(({ studioBuildingId }) => studioBuildingId === currentMapBuildingId) ?? null;
    }, [buildings, currentMapBuildingId]);

    const selectedFloor = useMemo(() => {
        if (!currentBuilding || !selectedFloorName || !Array.isArray(currentBuilding?.floors)) {
            return null;
        }
        return currentBuilding.floors.find((floor) => floor.name.ko === selectedFloorName);
    }, [currentBuilding, selectedFloorName]);

    return {
        selectedFloor,
    };
};
